import * as React from 'react';
import { EditorUtils } from '@progress/kendo-react-editor';
import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';

interface Shortcode {
  text: string;
  code: string;
  id: number;
}

interface InsertShortcodeToolProps {
  view: any;
}

export function createInsertShortcodeTool(items: Shortcode[]) {
  return class extends React.Component<InsertShortcodeToolProps> {
    handleShortcodeInsert = (event: DropDownButtonItemClickEvent) => {
      const selectedShortcode = event.item as Shortcode;

      if (!selectedShortcode.code) {
        return;
      }

      const { view } = this.props;
      const schema = view.state.schema;
      const nonEditableNodeType = schema.nodes.nonEditable;

      const shortcodeNode = nonEditableNodeType.createAndFill(
        { class: 'shortcode' },
        schema.text(selectedShortcode.code)
      );

      EditorUtils.insertNode(view, shortcodeNode);
      view.focus();
    };

    render() {
      const { view } = this.props;
      const canInsertTextNode = view && EditorUtils.canInsert(view.state, view.state.schema.nodes.text);

      return (
        <DropDownButton
          text="Field Codes"
          items={items}
          iconClass='k-icon k-i-plus'
          disabled={!canInsertTextNode}
          onItemClick={this.handleShortcodeInsert}
          style={{ userSelect: 'none' }}
        />
      );
    }
  };
}
